import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NonceService } from '../nonce.service';

@Injectable({
  providedIn: 'root',
})
export class NonceProvider {
  private static nonceSubject$ = new Subject<string>();

  private readonly nonceService = inject(NonceService);

  static getNonce(): Observable<string> {
    return NonceProvider.nonceSubject$.asObservable();
  }

  constructor() {
    this.nonceService.getNonce().then((nonce) =>
      NonceProvider.emitNonce(nonce),
    );
  }

  private static emitNonce(nonce: string | undefined): void {
    if (nonce !== undefined) {
      NonceProvider.nonceSubject$.next(nonce);
    }
  }
}
